import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import DocumentsApi from '../../services/api/DocumentsApi';
// import { createHash } from "crypto-pro";
import { DOCUMENT_TYPE } from '../../types';
import { DOCUMENTS_SEARCH_FILTERS } from '../../types';
import { RootState } from '../../types';
import { showError } from '../../utils/utils';

const setDocumentsLoading = createAction<{
  type: 'documents' | 'document' | 'documentPDF';
  value: boolean;
}>('documents/setLoading');

const getDocuments = createAsyncThunk(
  'documents/getDocuments',
  async (
    payload: {
      filters: DOCUMENTS_SEARCH_FILTERS;
      concat?: boolean;
    },
    thunkAPI
  ) => {
    try {
      thunkAPI.dispatch(
        setDocumentsLoading({ type: 'documents', value: true })
      );
      const rootState = thunkAPI.getState() as RootState;
      const { filters } = payload;
      const response = await DocumentsApi.getDocuments({
        ...filters,
        accountId: rootState.auth.account.id,
      });
      if (response.status === 200) {
        return {
          documents: response.data.content,
          pagination: {
            isLast: response.data.last,
            isFirst: response.data.first,
            specialFields: response.data.specialFields,
            total: response.data.totalElements,
          },
          concat: payload.concat,
        };
      }
      return { documents: [], pagination: { isLast: false, isFirst: false } };
    } catch (err) {
      showError(err, thunkAPI);
    } finally {
      thunkAPI.dispatch(
        setDocumentsLoading({ type: 'documents', value: false })
      );
    }
  }
);

const getDocument = createAsyncThunk(
  'documents/getDocument',
  async (
    payload: {
      id: number;
      type: DOCUMENT_TYPE;
    },
    thunkAPI
  ) => {
    try {
      thunkAPI.dispatch(setDocumentsLoading({ type: 'document', value: true }));
      const rootState = thunkAPI.getState() as RootState;
      const response = await DocumentsApi.getDocument(
        payload.id,
        rootState.auth.account.id,
        payload.type
      );
      if (response.status === 200) {
        return response.data;
      }
      return undefined;
    } catch (err) {
      showError(err, thunkAPI);
    } finally {
      thunkAPI.dispatch(
        setDocumentsLoading({ type: 'document', value: false })
      );
    }
  }
);

const getDocumentPDF = createAsyncThunk(
  'documents/getDocumentPDF',
  async (
    payload: { id: number; type: DOCUMENT_TYPE; signed: boolean },
    thunkAPI
  ) => {
    try {
      thunkAPI.dispatch(
        setDocumentsLoading({ value: true, type: 'documentPDF' })
      );
      const rootState = thunkAPI.getState() as RootState;
      const response = await DocumentsApi.getDocumentPDF(
        payload.id,
        rootState.auth.account.id,
        payload.type,
        payload.signed
      );
      if (response.status === 200) {
        // const bufferHash = await createHash(response.data);
        return {
          doc: btoa(String.fromCharCode(...new Uint8Array(response.data))),
          hash: '',
          // hash: bufferHash,
        };
      }
    } catch (err) {
      showError(err, thunkAPI);
    } finally {
      thunkAPI.dispatch(
        setDocumentsLoading({ value: false, type: 'documentPDF' })
      );
    }
    return undefined;
  }
);

export { setDocumentsLoading, getDocuments, getDocument, getDocumentPDF };
